/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import {
  ERROR_DELETE_GRANT_VIEW_ACCESS_USER,
  ERROR_UPDATE_VIEW_RELATIONSHIPS,
  ERROR_ADD_VIEW_RELATIONSHIPS,
} from 'state/grantViewAccess/GrantViewAccessActions';
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionError } from 'state/analytics/AnalyticsActions';

const FailedUpdateViewAccessLogic = createLogic({
  type: [ERROR_DELETE_GRANT_VIEW_ACCESS_USER, ERROR_UPDATE_VIEW_RELATIONSHIPS,ERROR_ADD_VIEW_RELATIONSHIPS],

  process({ action }, dispatch, done) {
    // dispatch user message
    const title = '';
    const message =
      'Unfortunately, we were unable to save the changes to your view access information due to an error in our processes. Please try again later.';
    dispatch(addToast(false, title, message));

    if (action.type === ERROR_DELETE_GRANT_VIEW_ACCESS_USER) {
      // dispatch analytics message
      dispatch(analyticsActionError('GrantViewAccessUserDelete'));
    }
    else if (action.type === ERROR_UPDATE_VIEW_RELATIONSHIPS) {
      dispatch(analyticsActionError('GrantViewAccessEdit'));
    }
    else {
      dispatch(analyticsActionError('GrantViewAccessUserAdd'));
    }

    done();
  }
});

export default FailedUpdateViewAccessLogic;
